/* @flow */
import React, { useContext } from "react";
import LocationCollection from "nexia_mobile/models/location_collection";
import Page from "nexia_mobile/components/Page";
import TrackedScrollableArea from "nexia_mobile/components/Scrollable/TrackedScrollableArea";
import TileList from "nexia_mobile/components/TileList";
import AppBarButtons from "nexia_mobile/components/TopBar/AppBarButtons";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  collection: LocationCollection,
  onNew: () => mixed,
};
const BuildingsPage = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.pages.BuildingsPage;
  const { collection, onNew } = props;
  return (
    <Page name="BuildingsPage" fullyLoaded>
      <AppBarWrapper>
        <CommonAppBarContainer
          title={language.title}
          iconRight={
            <AppBarButtons
              customActionTitle={language.newBuilding}
              onCustomAction={onNew}
            />
          }
        />
      </AppBarWrapper>
      <TrackedScrollableArea trackingKey="BuildingsPage">
        <TileList collection={collection} />
      </TrackedScrollableArea>
    </Page>
  );
};

export default BuildingsPage;



// WEBPACK FOOTER //
// ./src/components/Pages/BuildingsPage.jsx